import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'

export function PublicOnlyRoute() {
  const { isAuthenticated, isLoading, needsOnboarding } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (isAuthenticated && !needsOnboarding) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
